export const TranslationKeys = {
  radioDrawLabel: 'SignatureInput_radio_draw',
  radioTypeLabel: 'SignatureInput_radio_type',
};

export const TranslationNamespace = 'SignatureInput';
